export default "__VITE_ASSET__DOq7Qsuh__"